import { Injectable, signal } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { firstValueFrom, of } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { IndustrySector } from '../types/industry-sector.type'
import { environment } from '@environments/environment'
import { Response } from '../types/generic-response.type'
export type IndustrySectorsResponse = {
  industry_sectors: IndustrySector[]
}

@Injectable({ providedIn: 'root' })
export class IndustrySectorService {
  private sectors = signal<IndustrySector[]>([])

  constructor(private http: HttpClient) {}

  public loadIndustrySectors(): Promise<void> {
    return firstValueFrom(
      this.http.get<Response<IndustrySectorsResponse>>(`${environment.v2.baseUrl}generic/industry-sectors`).pipe(
        tap((data) => this.sectors.set(data.data.industry_sectors)),
        catchError((err) => {
          console.error('Failed to load industry sectors', err)
          return of([] as IndustrySector[])
        })
      )
    ).then(() => void 0)
  }

  public getIndustrySectors(): IndustrySector[] {
    return this.sectors()
  }
}
